import { createSlice } from "@reduxjs/toolkit";
import { createBatch } from "./createBatch";
import { fetchBatches } from "./findBatches";

interface MessagesState {
  success?: string;
  error?: string;
}

const initialState: MessagesState = {
  success: "",
  error: "",
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    clearMessage: (state) => {
      state.success = "";
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBatch.fulfilled, (state, action) => {
      const batchNumber = action.payload.data.batchNumber;
      state.success = `Saapumiserä #${batchNumber} tallennettu`;
      state.error = "";
    });
    builder.addCase(createBatch.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
    builder.addCase(fetchBatches.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const { actions, reducer } = messagesSlice;
export const { clearMessage } = actions;
export default reducer;
